import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { AdminAddon, CreateAddonRequest } from '@/api/types';

export type AddonFilters = {
  locationId?: string;
  sportCode?: string;
};

export function useAdminAddons(filters: AddonFilters = {}) {
  const params = new URLSearchParams();
  if (filters.locationId) params.set('locationId', filters.locationId);
  if (filters.sportCode) params.set('sportCode', filters.sportCode);
  const qs = params.toString();
  return useQuery({
    queryKey: ['adminAddons', filters],
    queryFn: () => apiClient<AdminAddon[]>(`/admin/addons${qs ? `?${qs}` : ''}`),
  });
}

export function useCreateAddon() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (request: CreateAddonRequest) =>
      apiClient<AdminAddon>('/admin/addons', {
        method: 'POST',
        body: JSON.stringify(request),
      }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['adminAddons'] }); },
  });
}

export function useUpdateAddon() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...request }: CreateAddonRequest & { id: string }) =>
      apiClient<AdminAddon>(`/admin/addons/${id}`, {
        method: 'PUT',
        body: JSON.stringify(request),
      }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['adminAddons'] }); },
  });
}

export function useDeleteAddon() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      apiClient<void>(`/admin/addons/${id}`, { method: 'DELETE' }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['adminAddons'] }); },
  });
}
